import {Food} from "./types";

const ChickenMeals: Food = {
    "Lemon Herb Chicken": {
        "Lemon Herb Chicken": "4.5oz",
        "Sweet Mashed Potatoes": "5oz (WHITE scoop)",
        "Roasted Broccoli": "2.5oz",
        "Garnish": "Lemon Zest over chicken"
    },
    "Chicken Parmigiana": {
        "Chicken Parm": "5oz",
        "Spaghetti": "4oz",
        "Garnish": "Fresh Parsley",
        "Side": "Fresh mozz slice & 14g fresh parm"
    },
    "Balsamic Chicken": {
        "Balsamic Chicken": "4.5oz",
        "Dinner Red Potatoes": "4.5oz",
        "Roasted Green Beans": "2.2oz",
        "Garnish": "Balsamic Glaze"
    },
    "Chicken Fajita": {
        "Blackened Chicken SLICED": "4.5oz",
        "Brown Rice": "5oz (WHITE scoop)",
        "Fajita Peppers & Onions": "2.5oz"
    },
    "Chicken Burrito Bowl": {
        "Diced Blackened Chx": "4.2oz",
        "Burrito Rice": "4.5oz OVERFILLED (WHITE scoop)",
        "Mexican Cheese": "14g",
        "Garnish": "Corn",
        "Sides": "Pico de gallo and Chipotle yogurt"
    },
    "Buffalo Chicken Quesadilla": {
        "Buffalo Chicken Quesadilla": "3 slices",
        "Sides": "Buffalo Ranch Dressing, 3 pieces of celery"
    },
        "Bang Bang Chicken": {
        "Bang Chicken": "4.2oz",
        "Peanut Noodles": "4oz",
        "Asian Slaw": "2.5oz",
        "Sides": "Bang Bang Sauce",
        "Garnish": "Roasted Sesame Seeds"
    },
        "BBQ Chicken": {
        "BBQ Chicken": "4.2oz",
        "Mac & Cheese": "4.5oz (GREY scoop)",
        "Boiled Green Beans": "2.2oz",
        "Sides": "BBQ Sauce"
    },
        "Teriyaki Chicken": {
        "Teriyaki Chicken": "4.5oz",
        "Jasmine Rice": "4.5oz (Grey scoop)",
        "Roasted Broccoli": "1.3oz",
        "Roasted Carrots": "1.3oz",
        "Garnish": "Teriyaki Glaze, Green Onions, Roasted Sesame Seeds"
    }
}

export default ChickenMeals